import axios from 'axios';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { CommonState, error, isFetching } from '@pec/aion-ui-core/slices/common';
import { enqueueRequestErrorSnackbar } from '@pec/aion-ui-core/actions/enqueueSnackbar';
import { OdataResponse } from '@pec/aion-ui-odata/types/odataResponse';
import { ICertification } from '../interfaces/certifications';

const name = 'certifications';

export const fetchCertifications = createAsyncThunk(`${name}/fetch`, async (organizationId: string, { dispatch }) => {
  try {
    const { data } = await axios.get<OdataResponse<ICertification[]>>(
      `/api/v1/accreditations/organizations/${organizationId}/certifications`
    );
    return data;
  } catch (error) {
    dispatch(enqueueRequestErrorSnackbar());
    throw error;
  }
});

export type State = CommonState & {
  certifications: ICertification[];
};

const initialState: State = {
  certifications: [],
  isFetching: false,
  error: null
};

const certifications = createSlice({
  name,
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchCertifications.pending, isFetching)
      .addCase(fetchCertifications.fulfilled, (state, action) => {
        state.certifications = action.payload.value.sort((a, b) => a.displayOrder - b.displayOrder);
        state.isFetching = false;
      })
      .addCase(fetchCertifications.rejected, error);
  }
});

export const { reducer: certificationsReducer } = certifications;
